import { render, staticRenderFns } from "./Overview1.vue?vue&type=template&id=6c0cfaf7&scoped=true"
import script from "./Overview1.vue?vue&type=script&lang=js"
export * from "./Overview1.vue?vue&type=script&lang=js"
import style0 from "./Overview1.vue?vue&type=style&index=0&id=6c0cfaf7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0cfaf7",
  null
  
)

export default component.exports